<script>
  import Container from "../../components/Container.svelte"

  export let cliente
  export let datos_adicionales
  export let calcularEdad
</script>

<Container>
  <h6 class="text-start">
    <i class="bi-person fg-secondary me-3"></i> Información del cliente
  </h6>

  <div class="table-responsive">
    <table class="table table-striped table-sm small">
      <tbody>
        <tr>
          <td class="fg-secondary">Nombres</td>
          <td>{cliente.nombres}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Documento</td>
          <td>{cliente.documento}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Nacimiento</td>
          <td>{datos_adicionales.generales.nacimiento}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Sexo</td>
          <td>{datos_adicionales.generales.sexo}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Estado civil</td>
          <td>{datos_adicionales.generales.est_civil}</td>
        </tr>
        <tr>
          <td class="fg-secondary">Nivel de educación</td>
          <td>{datos_adicionales.generales.nivel_educacion}</td>
        </tr>
      </tbody>
    </table>
  </div>
</Container>
